import React, { forwardRef } from "react";
import styled from "styled-components";
import { Button, ButtonProps, propStyling, tombac } from "tombac";

export const Dot = styled.span<{
  breakpoint?: number;
  variant?: "alert" | "danger";
}>`
  all: initial;

  background-color: ${({ variant = "danger" }) => tombac.color(variant, 500)};
  border: ${tombac.unit(2)} solid ${tombac.color.white};
  border-radius: 50%;
  cursor: inherit;
  height: ${tombac.unit(7)};
  position: absolute;
  right: ${tombac.unit(7)};
  width: ${tombac.unit(7)};
  top: ${tombac.unit(7)};

  @media (max-width: ${({ breakpoint = 768 }) => tombac.unit(breakpoint)}) {
    border: 0;
    height: ${tombac.unit(10)};
    margin-left: auto;
    position: static;
    width: ${tombac.unit(10)};
  }
`;

export const IconButton = forwardRef(({ as, ...props }: ButtonProps, ref) => (
  <StyledIconButton
    shape="circle"
    variant="flat"
    {...(props as any)}
    forwardedAs={as}
    ref={ref}
  />
)) as typeof Button;

const StyledIconButton = styled(Button)`
  position: relative;

  & svg {
    display: block;
  }

  ${propStyling}
`;
